import { useMemo } from 'react';
import { usePracticeOptions } from '../../../hooks/useBilling';

// The list carries no doctor, so the same cached practice lookup PracticeMultiSelect uses fills it in.
export function usePracticeDoctorNames(): ReadonlyMap<string, string> {
    const { practices } = usePracticeOptions();
    return useMemo(
        () =>
            new Map(
                practices.flatMap((practice) =>
                    practice.doctorName ? [[practice.id, practice.doctorName] as const] : []
                )
            ),
        [practices]
    );
}
